/**
 * Központi auth helper — mindig ebből olvassuk a tokent a közvetlen fetch() hívásokhoz.
 */
export function getAccessToken(): string | null {
  return localStorage.getItem('accessToken');
}
